import * as LJS from "../../lib/littlejs.esm";
import { tilesize, tilesheets } from '../const/tiles.ts';
import Globals from '../globals.ts';
class Lava extends LJS.EngineObject {
    constructor(pos) {
        let tileIndex = 108;
        let darkTile = LJS.tile(tileIndex, tilesize, tilesheets.DARK);
        // We need to offset the x-position by half the width because LittleJS centers is
        pos.x += Globals.WELL_WIDTH / 2 + 0.5;
        // We do the same for the y position (half of the height, which is 32, so 16)
        // The lava has a negative offset because we want the y spawn to be the top of the lava
        pos.y -= 16 - 0.5;
        super(pos, LJS.vec2(Globals.WELL_WIDTH, 32), darkTile);
        this.walkable = false;
        this.tilesX = Globals.WELL_WIDTH;
        this.tilesY = 32;
        this.tileSize = 1;
        this.darkTile = darkTile;
        this.lightTile = LJS.tile(tileIndex, tilesize, tilesheets.LIGHT);
        this.mass = 0; // Not affected by gravity
    }
    get tile() {
        return Globals.world == Globals.DARK ? this.darkTile : this.lightTile;
    }
    render() {
        const tile = this.tile;
        for (let y = 0; y < this.tilesY; y++) {
            for (let x = 0; x < this.tilesX; x++) {
                const drawPos = LJS.vec2(this.pos.x - this.size.x / 2 + x * this.tileSize + this.tileSize / 2, this.pos.y + this.size.y / 2 - y * this.tileSize - this.tileSize / 2);
                const n = this.smoothNoise(x * 0.4 + y * 0.6 + LJS.time * 0.8);
                const yOffset = (n - 0.5) * 0.25;
                LJS.drawTile(LJS.vec2(drawPos.x, drawPos.y + yOffset), LJS.vec2(this.tileSize), tile, LJS.WHITE);
            }
        }
    }
    smoothNoise(v) {
        const i = Math.floor(v);
        const f = v - i;
        const a = Math.sin(i * 12.9898) * 43758.5453 % 1;
        const b = Math.sin((i + 1) * 12.9898) * 43758.5453 % 1;
        return LJS.lerp(a, b, f);
    }
    update() {
        if (Globals.gameState === 'gameOver')
            return;
        this.pos.y -= Globals.descentSpeed;
        // Check for overlap with player
        if (Globals.player && LJS.isOverlapping(this.pos, this.size, Globals.player.pos, Globals.player.size)) {
            Globals.player.die();
        }
        super.update();
    }
}
export default Lava;
